import { observer } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import lunchBreakPromptStore from "../../../stores/LunchBreak/lunchBreakPromptStore";

/** "6.17" hours → "6 Std. 10 Min." — human-readable duration (MD-238 P6). */
const formatHoursMinutes = (hours: number): string => {
  const totalMinutes = Math.round(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (m === 0) return `${h} Std.`;
  if (h === 0) return `${m} Min.`;
  return `${h} Std. ${m} Min.`;
};

/**
 * Global dialog asking whether to keep or delete a lunch break that is no
 * longer legally required (day work time below the threshold). Rendered once at
 * the app root; driven by lunchBreakPromptStore. Closing via backdrop/escape
 * defaults to keeping the break (the non-destructive choice).
 */
const LunchBreakPromptDialog = observer(() => {
  const { open, context } = lunchBreakPromptStore;

  return (
    <Dialog
      open={open}
      onClose={() => lunchBreakPromptStore.chooseKeep()}
      PaperProps={{ style: { zIndex: 2100 } }}
      slotProps={{ backdrop: { style: { backgroundColor: "transparent" } } }}
    >
      <DialogTitle>Pause nicht mehr erforderlich</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Mit dieser Änderung liegt die Arbeitszeit
          {context ? ` (${formatHoursMinutes(context.workHours)})` : ""} unter der
          gesetzlichen Grenze für eine Pause. Möchten Sie die bestehende Pause behalten oder löschen?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => lunchBreakPromptStore.chooseDelete()}>
          Pause löschen
        </Button>
        <Button variant="contained" onClick={() => lunchBreakPromptStore.chooseKeep()}>
          Pause behalten
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default LunchBreakPromptDialog;
